<template>
    <modal
        name="logout-login-form"
        class="modal--translation modal--hide-on-loading"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    >
        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0"><i class="fa fa-sign-out-alt mr-2"></i> {{ trans('title') }}</h5>
        </div>

        <div class="modal-body p-0" :class="{'loading': loading }">
            <div class="row">
                <div class="col-md-12">
                    <p>{{ trans('description') }}</p>
                </div>
            </div>
        </div>

        <div class="modal-footer text-center">
            <b-button type="button" variant="danger" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-check mr-2"></i> {{ trans('submit') }}</b-button>
        </div>
    </modal>
</template>

<script>
import TranslationsUtils from "../../app-components/TranslationsUtils";

export default {
    mixins: [TranslationsUtils],

    props: {
        'baseUrl': {
            type: String
        },
        'onsuccess': {
            type: Function
        },
    },

    data: function() {
        return {
            loading: false,
            itemId: null,
            url: this.baseUrl,
        };
    },

    methods: {
        open(id) {
            this.itemId = id;
            this.url = this.baseUrl.replace('__id__', id);
            this.$modal.show('logout-login-form');
        },

        submitForm() {
            this.loading = true;

            axios.post(this.url)
                .then(success => {
                    if(success.data.redirect) {
                        window.location.href = success.data.redirect;
                        return;
                    }

                    this.closeModal();
                    this.$notify({ type: 'success', title: success.data.message });

                    if(typeof this.onsuccess !== 'undefined') {
                        this.onsuccess();
                    } else {
                        window.location.reload();
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.closeModal();
                    if(error.response) {
                        this.$notify({ type: 'error', title: error.response.data.message });
                    }

                    if(typeof this.onsuccess !== 'undefined') {
                        this.onsuccess();
                    }
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('logout-login-form');
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0 0 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/LogoutLogin.vue